import React from "react";
import { Link } from "react-router-dom";

const Breadcrumb = ({ title, addressEnumChange, isChildren = false }) => {

  const handleBack = () => {
    addressEnumChange(0);
  }

  return (
    <div className='breadcrumb mb-0 py-20 bg-main-one-50'>
      <div className='container container-md'>
        <div className='breadcrumb-wrapper flex-between flex-wrap gap-16'>
          <div className="d-flex align-items-center gap-16">
            {
              isChildren && (
                <button onClick={handleBack} className="w-20 h-20 flex-center"><i class="ph ph-arrow-left text-xl fw-bold h-100"></i></button>
              )
            }
            <h6 className='mb-0 text-xl text-main-one-600'>{title}</h6>
          </div>
          
          <ul className='flex-align gap-8 flex-wrap'>
            <li className='text-md'>
              <Link
                to='/'
                className='text-gray-900 flex-align gap-8 hover-text-main-one-600'
              >
                <i className='ph ph-house' />
                Home
              </Link>
            </li>
            
            <li className='flex-align'>
              <i className='ph ph-caret-right' />
            </li>
            <li className='text-md text-main-one-600'> {title} </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
